import { applyMiddleware, createStore, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
// import { createLogger } from 'redux-logger';
import { save, load } from 'redux-localstorage-simple'

import rootReducer from 'redux/reducers'

// const loggerMiddleware = createLogger();

export default function configureStore(preloadedState = {}) {
  const middlewares = [
    thunkMiddleware,
    save({
      ignoreStates: [
        'unsaved',
        'creditCards',
        'admins',
        'campaigns',
        'dashboard',
        'analytics',
        'admins',
        'editPlacements',
        'superAdmin'
      ]
    })
  ] // loggerMiddleware
  const middlewareEnhancer = composeWithDevTools(
    applyMiddleware(...middlewares)
  )

  const enhancers = [middlewareEnhancer]
  const composedEnhancers = compose(...enhancers)

  const store = createStore(rootReducer, load(), composedEnhancers)

  return store
}
